import { Component, Input } from '@angular/core';
import { ParamsModel } from '../../models/params.model';
import { MatchDataService } from '../../services/match-data.service';
import { environment } from '../../../../../environments/environment';
import { CommonModule } from '@angular/common';
import { NzSkeletonComponent } from 'ng-zorro-antd/skeleton';
import { TranslateModule } from '@ngx-translate/core';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NoResultComponent } from '../../../../components/shared/no-result/no-result.component';

@Component({
  selector: 'app-lineup',
  standalone: true,
  imports: [CommonModule, NzSkeletonComponent, TranslateModule, NzCardModule, NoResultComponent],
  templateUrl: './lineup.component.html',
  styleUrl: './lineup.component.scss',
})
export class LineupComponent {
  infoMatch: any;
  @Input() set paramsSet(params: any) {
    this.params = params;
  }
  @Input() set infoMatchSelected(infoMatchSelected: any) {
    this.infoMatch = {
      homeTeam: infoMatchSelected.homeTeam.name,
      awayTeam: infoMatchSelected.awayTeam.name,
    };
  }

  lineUp: any | null = null;
  loading = true;
  params: ParamsModel = {} as ParamsModel;

  urlImg = environment.urlIMG;

  private reasonArray = ['Red card suspension', 'Yellow card suspension'];

  iconIncidents: any = {
    1: './assets/img/gol.png',
    3: './assets/img/yellow-card.png',
    4: './assets/img/red-card.png',
    8: './assets/img/gol.png',
    9: './assets/img/change-player.png',
    11: './assets/img/whristle.png',
    12: './assets/img/whristle.png',
    15: './assets/img/var-icon.png',
    16: './assets/img/gol-failed.png',
    17: './assets/img/gol.png',
    19: './assets/svg/time.svg',
    26: './assets/img/whristle.png',
    27: './assets/img/whristle.png',
    28: './assets/img/var-icon.png',
    29: './assets/img/gol.png',
    30: './assets/img/gol-failed.png',
  };

  constructor(private readonly matchServices: MatchDataService) {}

  ngOnInit(): void {
    this.loadLineUp(this.params);
  }

  loadLineUp(params: ParamsModel) {
    this.matchServices.getLineUpTeams(params).subscribe(
      (result: any) => {
        if (result && result.status) {
          this.lineUp = result;
          this.loading = false;
        } else {
          this.lineUp = {
            status: false,
          };
          this.loading = false;
        }
      },
      () => {
        this.lineUp = {
          status: false,
        };
        this.loading = false;
      }
    );
  }

  validReason(value: string): string {
    return this.reasonArray.includes(value) ? value : 'Injury';
  }

  transform(text: string, length: number = 50, suffix: string = '...'): string {
    if (text.length > length)
      return text.substring(0, length).trim().concat(suffix);
    return text;
  }

  showIncident(incident:any, player:any) {
    return (incident.player && incident.player.id === player.id && [1, 8, 16, 17, 29, 30].includes(incident.type)) || [3, 4].includes(incident.type);
  }

  getIncidentPlayerName(incident:any, player:any) {
    return incident.type === 9 ? incident.out_player.id !== player.id ? incident.out_player.name : incident.in_player.name : '';
  }
}
